import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, computed } from "vue"
import { useMutation } from "@/hooks/useMutation"
import { useNotification } from "@/hooks/useNotification"
import {
  AuthProvider,
  LoginMutation,
  LoginMutationMutation,
  LoginMutationMutationVariables,
} from "@/gql"
import LoginData from "./data.json"
import useRouter from "@/router/useRouter"
import { apolloProvider } from "@/main"
import Checkbox from "@/components/widgets/input/Checkbox.vue"
import store from "@/store"
import { useAuth } from "@/store/auth/useAuth"

type LoginForm = {
  email: string | null
  password: string | null
  mode: AuthProvider
  keepMeLoggedIn: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

function isLoggedIn(): boolean {
  return store.getters["auth/isLoggedIn"]
}

const { startSession } = useAuth()
const { addSuccess, addError } = useNotification()
const { mutate } = useMutation()

const form = ref<LoginForm>({
  email: null,
  password: null,
  mode: AuthProvider.Password,
  keepMeLoggedIn: false,
})

const isSubmitting = ref(false)
const contentData = ref(LoginData.content)
const contentIndex = ref(Math.floor(Math.random() * contentData.value.length))
const contentRenderedData = computed(() => contentData.value[contentIndex.value])

const isUserLoggedIn = computed(() => {
  return isLoggedIn()
})

const normalize = (input: string) => {
  return typeof input === "string" ? input.trim().toLowerCase() : input
}

const { postSignInRedirectRoute, unsetPostSignInRedirectRoute, navigate, router, routes } =
  useRouter()

const onLoginChange = () => {
  const redirectRoute = postSignInRedirectRoute()

  if (redirectRoute) {
    unsetPostSignInRedirectRoute()
    return navigate(redirectRoute)
  }

  if (router.currentRoute.name === routes.Login) {
    return navigate("/")
  }
}

watch(isUserLoggedIn, () => {
  if (isUserLoggedIn.value) {
    onLoginChange()
  }
})

const onSubmit = async () => {
  if (!form.value.email || !form.value.password) return

  isSubmitting.value = true

  await mutate<LoginMutationMutation, LoginMutationMutationVariables>({
    mutation: LoginMutation,
    variables: {
      email: normalize(form.value.email),
      password: form.value.password,
      mode: AuthProvider.Password,
    },

    done: () => {
      isSubmitting.value = false
    },
    onSuccess: (data) => {
      if (data) {
        if (data.login.user && data.login.token) {
          startSession({
            user: data.login.user,
            token: `Bearer ${data.login.token}`,
            apolloProvider: apolloProvider,
          })
        }
      }
      addSuccess("Login successful")
    },
    onMutationError: (error) => {
      addError(error.message)
    },
  })
}

return { __sfc: true,isLoggedIn, startSession, addSuccess, addError, mutate, form, isSubmitting, contentData, contentIndex, contentRenderedData, isUserLoggedIn, normalize, postSignInRedirectRoute, unsetPostSignInRedirectRoute, navigate, router, routes, onLoginChange, onSubmit, AuthProvider, Checkbox }
}

})